module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_mediaon.72e83c8216796dacf7b3cfd0ea25bc75.png";